/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId
     */
    GameSystemName: string;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId {
    if (json == null) {
        return json;
    }
    return {
        
        'GameSystemName': json['GameSystemName'],
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxIdToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFxId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'GameSystemName': value['GameSystemName'],
    };
}

